import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

import DesktopHeader from "./components/DesktopHeader";
import MobileHeader from "./components/MobileHeader";

export default function Header({ modules = [], activeKey = "" }) {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const headerPalette = theme.palette.header ?? {
    background: theme.palette.secondary.main,
    text: theme.palette.secondary.contrastText,
    border: theme.palette.divider,
    shadow: "none",
  };

  if (!Array.isArray(modules) || modules.length === 0) return null;

  const handleMobileChange = (event) => {
    const selectedKey = event?.target?.value;
    if (!selectedKey) return;
    const selectedModule = modules.find((item) => item?.key === selectedKey);
    if (!selectedModule?.path) return;
    navigate(selectedModule.path);
  };

  return (
    <AppBar
      position="sticky"
      color="transparent"
      sx={{
        top: 0,
        zIndex: 99,
        backgroundColor: headerPalette.background,
        color: headerPalette.text,
        borderBottom: `1px solid ${headerPalette.border}`,
        boxShadow: headerPalette.shadow,
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: { xs: "stretch", sm: "center" },
          gap: 1,
          color: "inherit",
          minHeight: { xs: "auto !important", sm: "64px !important" },
          py: { xs: 0, sm: 0 },
        }}
      >
        <Box flexGrow={1} display="flex" justifyContent={isMobile ? "center" : "flex-start"} sx={{ minWidth: 0 }}>
          {isMobile ? (
            <MobileHeader modules={modules} activeKey={activeKey} onChange={handleMobileChange} />
          ) : (
            <DesktopHeader modules={modules} activeKey={activeKey} />
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
}
